import { Modal } from "antd";
import styles from "./styles.module.scss";
import { UploadedFiles } from "./uploaded-files";
import { FileUpload } from "./file-upload";
import { UseApiCallV2 } from "hooks";
import { useParams } from "react-router-dom";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { ConditionalRenderer } from "components";

export const UploadFilesModal = ({
  fileData,
  open,
  handleCloseModal,
  refetchLegalDocs,
  refetchDetail,
  refetchAllUploadedFiles,
  dropdownsListObj,
  refetchCount,
}) => {
  const documentType = fileData?.key;
  const { caseId } = useParams();
  const {
    data: uploadedFiles,
    isLoading,
    refetch,
  } = UseApiCallV2({
    url: "/get_document_list",
    method: "POST",
    skip: !documentType,
    paramsData: {
      documentType,
      case_id: caseId,
    },
  });

  return (
    <Modal
      destroyOnClose
      title={<ModalTitle documentName={fileData?.key} />}
      // title="Set Reminder"
      open={open}
      onCancel={handleCloseModal}
      footer={null}
      centered
      width="97dvw"
      styles={{
        content: {
          backgroundColor: "#F5F6F8",
          height: "97dvh",
        },
        header: { backgroundColor: "#F5F6F8" }, // turns the Modal red
      }}
    >
      <div>
        <FileUpload
          fileData={fileData}
          refetchLegalDocs={refetchLegalDocs}
          refetchUploaded={refetch}
          refetchDetail={refetchDetail}
          refetchAllUploadedFiles={refetchAllUploadedFiles}
          dropdownsListObj={dropdownsListObj}
          refetchCount={refetchCount}
        />
        {/* <UploadFiles /> */}
        <UploadedFiles
          uploadedFiles={uploadedFiles}
          isLoading={isLoading}
          documentType={documentType}
          refetchUploaded={refetch}
          refetchLegalDocs={refetchLegalDocs}
          refetchDetail={refetchDetail}
          dropdownsListObj={dropdownsListObj}
          refetchCount={refetchCount}
        />
      </div>
    </Modal>
  );
};
function ModalTitle({ documentName }) {
  const { translator } = useLanguageTranslator();

  return (
    <div className={styles.modalTitle}>
      {translator("caseDetail.uploadFiles.uploadBtnText")} -{" "}
      <span>{translator("caseDetail.legalDocs")[documentName]}</span>
    </div>
  );
}
